import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/icons/close.svg'


const _hoisted_1 = {
  id: "alerts_panel",
  class: "clear_all_widgets_on_click"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", { id: "alert_header" }),
  /*#__PURE__*/_createElementVNode("img", {
    id: "close_alerts_panel",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { id: "alerts_panel_type" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { id: "alerts_panel_confidence" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("select", { id: "alerts_panel_resolution" }, null, -1)
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  class: "k-primary k-button",
  id: "previous_alert"
}
const _hoisted_8 = {
  class: "k-primary k-button",
  id: "next_alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.t('alerts.score')) + ": ", 1),
      _hoisted_4
    ]),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.t('alerts.resolution')) + ": ", 1),
      _hoisted_5
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("textarea", {
        id: "alerts_panel_comments",
        placeholder: _ctx.t('alerts.comments')
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.t('alerts.previous')), 1),
      _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.t('alerts.next')), 1)
    ])
  ]))
}